import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalConstants } from './global-variables';

@Injectable({ providedIn: 'root' })
export class AubTrackingService {

	constructor(private http: HttpClient, public GlobalConstants: GlobalConstants) {
	}

	aubts_poshvine_login(mobile: any) {
		this.dispatchEvent('Poshvine Login', { 'mobilenumber': mobile });

	}

	aubts_poshvine_registered(mobile: any) {
		this.dispatchEvent('Poshvine registered', { 'mobilenumber': mobile });

	}

	aubts_login(mobile: any) {
		this.dispatchEvent('Logged In', { 'Mobile': mobile });

	}

	aubts_offers_search(offer: any) {
		this.dispatchEvent('Offer Searched', { 'keyword': offer });

	}

	aubts_offer_clicked(offer: { name: any; brand: any; category: any; validity: any; }) {
		this.dispatchEvent('Offers clicked', {
			'Offername': offer.name,
			'Brand': offer.brand,
			'Category': offer.category,
			'Offervalidity': offer.validity
		});

	}

	aubts_offer_redeemed(offer: { name: any; brand: any; category: any; validity: any; redeem_date: any; }) {
		this.dispatchEvent('Offers redeemed', {
			'Offername': offer.name,
			'Brand': offer.brand,
			'Category': offer.category,
			'Offervalidity': offer.validity,
			'Redeemeddate': offer.redeem_date,
		});

	}

	aubts_category(category: any) {
		this.dispatchEvent('Category browsed', { 'Category Name': category });

	}

	aubts_offer_nearby(nearby: any) {
		this.dispatchEvent('Offers Near me clicked', {
			'City': nearby.city,
			'Locality': nearby.locality,
			'Pincode': nearby.pincode
		});

	}
	dispatchEvent(eventTitle: string, eventObject: any) {
		if (this.GlobalConstants.data.personalized_config.custom_gtm_tags 
			&& window && (window as any).smartech) {
			(window as any).smartech('dispatch', eventTitle, eventObject);
		}
	}
}
